// extracted by mini-css-extract-plugin
export default {"root":"IntegrationCard_root__qKfCp","logoWrapper":"IntegrationCard_logoWrapper__XInPo","logo":"IntegrationCard_logo__67CWT"};